import React, { FC } from 'react';
import ArrowLeft from '@crehana/crehana-icons/lib/NewArrowLeft';
import ArrowRight from '@crehana/crehana-icons/lib/NewArrowRight';

import { primaryMain, secondaryLight } from '../../../styles/colors';
import transition from '../../../styles/transition';
import BaseButton from '../../../Buttons/BaseButton';

interface ArrowButtonProps {
  direction: 'left' | 'right';
  disabled: boolean;
  onClick: () => void;
  dark?: boolean;
}

const ArrowButton: FC<ArrowButtonProps> = ({
  direction,
  disabled,
  onClick,
  dark,
}) => {
  const ArrowIcon = direction === 'left' ? ArrowLeft : ArrowRight;

  return (
    <BaseButton
      className={`w-72 h-72 flex-shrink-0 ${
        dark ? 'bg-base-dark' : 'bg-white'
      }`}
      css={`
        & > svg {
          transition: ${transition('opacity')};
        }
      `}
      onClick={onClick}
      disabled={disabled}
    >
      <ArrowIcon
        size={24}
        color={dark ? secondaryLight : primaryMain}
        className={disabled ? 'opacity-32' : ''}
      />
    </BaseButton>
  );
};

export default ArrowButton;
